import { DocumentIcon } from "@heroicons/react/24/outline";
import { FC, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { BookContext } from "../../contexts/BookContext";
import { GenerateBookPDFModal } from "../Modals/GenerateBookPDFModal";
import { Tooltip } from "../Tooltip";

export const GenerateBookPDFButton: FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { book } = useContext(BookContext);
  const isReadyForPDFGen = book?.status === "completed";

  const onClick = () => {
    setIsModalOpen(true);
  };

  const bgClasses = !isReadyForPDFGen
    ? "bg-gray-300"
    : "bg-sand-500 hover:bg-sand-800";

  const classes =
    "inline-flex items-center gap-x-1 sm:gap-x-2 rounded px-2 sm:px-3.5 py-1.5 sm:py-2.5 text-xs sm:text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sand-600";

  return (
    <>
      <Tooltip
        visible={!isReadyForPDFGen}
        text={t("generateBookPDFModal.tooltip")}
        position="bottom"
      >
        <button
          type="button"
          onClick={() => isReadyForPDFGen && onClick()}
          className={[classes, bgClasses].join(" ")}
          disabled={!isReadyForPDFGen}
        >
          <DocumentIcon className="w-4 h-4 sm:w-5 sm:h-5" />
          <span className="hidden sm:inline">
            {t("generateBookPDFModal.title")}
          </span>
          <span className="sm:hidden">PDF</span>
        </button>
      </Tooltip>

      <GenerateBookPDFModal open={isModalOpen} setOpen={setIsModalOpen} />
    </>
  );
};
